import { useState } from "react";
import { Palette, Check } from "lucide-react";
import { useThemeStore } from "@/store/themeStore";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ThemeColor } from "@/libs/theme";

const themeColors = [
  { name: "Blue", value: "blue" as ThemeColor, preview: "bg-blue-500" },
  { name: "Pink", value: "pink" as ThemeColor, preview: "bg-pink-500" },
];

export function ThemeColorPicker() {
  const { themeColor, setThemeColor } = useThemeStore();
  const [open, setOpen] = useState(false);

  const handleColorChange = (color: ThemeColor) => {
    setThemeColor(color);
    setOpen(false);
  };

  const currentTheme = themeColors.find((t) => t.value === themeColor);

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        {/* <Button variant="ghost" size="icon">
          <Palette className="h-5 w-5" />
        </Button> */}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {themeColors.map((theme) => (
          <DropdownMenuItem
            key={theme.value}
            onClick={() => handleColorChange(theme.value)}
            className="flex items-center gap-3"
          >
            <div className="flex items-center gap-2">
              <div className={`w-4 h-4 rounded-full ${theme.preview}`} />
              <span className="text-sm">{theme.name}</span>
            </div>
            {theme.value === themeColor && (
              <Check className="h-4 w-4 ml-auto" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
